/**
 * Created by Daniel Wang on 2/6/2024.
 * Description: usage report model
 * ------ maintenance history ------
 */

//#region login usage report
export class LoginUsageReport {
    loginID: string;
    username: string;
    lastLogin: Date;
    lastLoginType: string;
    lastActive: Date;
    lastActiveType: string;
    lastSubmission: Date;
    contentCount: string;

    static parse(res): LoginUsageReport {
        if (!res) {
            return;
        }
        const result = new LoginUsageReport();
        result.loginID = res['LoginID'];
        result.username = res['Username'];
        result.lastLogin = res['LastLogin'] ? new Date(res['LastLogin']) : null;
        result.lastLoginType = res['LastLoginType'];
        result.lastActive = res['LastActive'] ? new Date(res['LastActive']) : null;
        result.lastActiveType = res['LastActiveType'];
        result.lastSubmission = res['LastSubmission'] ? new Date(res['LastSubmission']) : null;
        result.contentCount = res['ContentCount'];

        return result;
    }
}
//#endregion

